import React, { useState } from 'react';
import { usePeriodo } from '../contexts/PeriodoContext';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Badge } from './ui/badge';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from './ui/popover';
import { 
  Calendar, ChevronLeft, ChevronRight, Settings2, RotateCcw
} from 'lucide-react';

const SeletorPeriodo = () => {
  const { 
    periodoSelecionado, 
    periodoAnterior, 
    proximoPeriodo, 
    alterarPeriodo,
    resetarPeriodo,
    loading 
  } = usePeriodo();
  
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [dataInicioTemp, setDataInicioTemp] = useState('');
  const [dataFimTemp, setDataFimTemp] = useState('');

  if (loading || !periodoSelecionado) {
    return (
      <div className="flex items-center gap-2 text-sm text-slate-400">
        <Calendar className="w-4 h-4" />
        Carregando...
      </div>
    );
  }

  const handleAbrirPopover = () => {
    setDataInicioTemp(periodoSelecionado.data_inicio);
    setDataFimTemp(periodoSelecionado.data_fim);
    setPopoverOpen(true);
  };

  const handleAplicarPeriodo = () => {
    if (dataInicioTemp && dataFimTemp) {
      alterarPeriodo(dataInicioTemp, dataFimTemp);
      setPopoverOpen(false);
    }
  };

  return (
    <div className="flex items-center gap-1 bg-slate-800/50 rounded-lg px-2 py-1">
      {/* Botão Período Anterior */}
      <Button
        variant="ghost"
        size="icon"
        className="h-7 w-7 text-slate-400 hover:text-white hover:bg-slate-700"
        onClick={periodoAnterior}
        title="Período anterior"
      >
        <ChevronLeft className="w-4 h-4" />
      </Button>

      {/* Seletor de Período */}
      <Popover open={popoverOpen} onOpenChange={setPopoverOpen}>
        <PopoverTrigger asChild>
          <Button
            variant="ghost"
            className="h-7 px-2 text-slate-300 hover:text-white hover:bg-slate-700 font-normal text-sm gap-1.5"
            onClick={handleAbrirPopover}
          >
            <Calendar className="w-3.5 h-3.5" />
            <span className="hidden sm:inline">{periodoSelecionado.descricao}</span>
            <span className="sm:hidden">{periodoSelecionado.mes_referencia?.split(' ')[0]}</span>
            {periodoSelecionado.personalizado && (
              <Badge variant="outline" className="ml-1 h-4 text-[10px] bg-amber-500/20 text-amber-400 border-amber-500/30">
                Custom
              </Badge>
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-72 p-3" align="center">
          <div className="space-y-3">
            <div className="text-sm font-medium text-slate-700">Selecionar Período</div>
            
            <div className="grid grid-cols-2 gap-2">
              <div>
                <label className="text-xs text-slate-500">Início</label>
                <Input
                  type="date"
                  value={dataInicioTemp}
                  onChange={(e) => setDataInicioTemp(e.target.value)}
                  className="h-8 text-sm"
                />
              </div>
              <div>
                <label className="text-xs text-slate-500">Fim</label>
                <Input
                  type="date"
                  value={dataFimTemp}
                  onChange={(e) => setDataFimTemp(e.target.value)}
                  className="h-8 text-sm"
                />
              </div>
            </div>

            <div className="flex gap-2">
              <Button
                variant="outline"
                size="sm"
                className="flex-1 h-8 text-xs"
                onClick={() => {
                  resetarPeriodo();
                  setPopoverOpen(false);
                }}
              >
                <RotateCcw className="w-3 h-3 mr-1" />
                Padrão
              </Button>
              <Button
                size="sm"
                className="flex-1 h-8 text-xs"
                onClick={handleAplicarPeriodo}
              >
                Aplicar
              </Button>
            </div>
          </div>
        </PopoverContent>
      </Popover>

      {/* Botão Próximo Período */}
      <Button
        variant="ghost"
        size="icon"
        className="h-7 w-7 text-slate-400 hover:text-white hover:bg-slate-700"
        onClick={proximoPeriodo}
        title="Próximo período"
      >
        <ChevronRight className="w-4 h-4" />
      </Button>
    </div>
  );
};

export default SeletorPeriodo;
